























import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import DownloadReportsCard
  from '@/components/reports/DownloadReportsCard.vue';
import FiReportsFormatCard
  from '@/components/reports/FiReportsFormatCard.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    DownloadReportsCard,
    FiReportsFormatCard,
  },
})
export default class Reports extends Vue {
    headerItems: any = [{
      text: 'Rewards Processing',
      disabled: false,
      link: false,
    },
    {
      text: 'Reports',
      disabled: true,
    }];
}
